import {
  AUSTRALIA_NEWZEALAND_PAGE,
  WORKDAY_EN_PATH,
} from "../../../../interfaces/Static/routing_paths";
import { AUSTRALIA_NEWZEALAND_PROGRAM } from "./_programs";

import motor_business from "../../../../assets/images/oceania/motor_business.webp";
import motor_business_banner from "../../../../assets/images/oceania/motor_business_banner.webp";

const ANZ_LOCATIONS = {
  id: 1,
  name: "Australia & New Zealand",
  slug: "melbourne-victoria-nma",
  items: AUSTRALIA_NEWZEALAND_PROGRAM.filter(
    (x) => ["melbourne-victoria-nma"].indexOf(x.slug) >= 0
  ),
};

export const MOTOR_BUSINESS = {
  id: "motor-business",
  card_src: motor_business,
  card_title: "page.oceania.motor_business",
  card_description: "page.oceania.motor_business_description",
  banner_src: motor_business_banner,
  banner_title: "page.oceania.motor_business",
  banner_description: "Prepare to Explore",
  slug: "motor-business",
  href: `${AUSTRALIA_NEWZEALAND_PAGE}/motor-business`,
  name: "page.oceania.motor_business",
  description:
    "At Nissan, our Sales and Marketing teams bring innovation and excitement to life, delivering our award-winning vehicles to customers across Australia and New Zealand through our extensive Dealer Network. Behind the scenes, our Product Marketing specialists collaborate with regional and global teams to shape our future vehicle line-up, years in advance, ensuring the Nissan brand stands strong in highly competitive markets. <br /> <br /> Our Sales and Aftersales teams work hand-in-hand with Dealers, equipping them with tools and insights to create outstanding customer experiences every step of the way. Meanwhile, our local Engineering team leads the way in performance innovation, partnering with Premcar to develop the Patrol and Navara Warrior, uniquely engineered for Australian conditions. Whether your future lies in customer engagement, strategic marketing, or product innovation, Nissan offers endless pathways to grow and make your mark across the business. All united by our mission to bring the Excitement of Innovation to everyone and ‘Defy Ordinary’.",
  categories: [
    {
      id: 1,
      name: "Established Presence",
      slug: "established_presence",
      description:
        "Nissan Motor Co. (Australia) Pty Ltd established its Melbourne Headquarters in 1972. For 20 years, Nissan assembled a variety of vehicles locally but became a full importer of vehicles when local car assembly stopped in 1992. Nissan Australia & NZ remains a Sales and Marketing based organisation with distribution of its vehicle range all over the country to its various franchise partners (authorised Nissan dealers). <br /><br /> “As the only Australian automotive OEM to continue to manufacture in Australia through our casting plant and the third largest OEM employer, Nissan has enormous strength and heritage in the Australian market. We are excited by our future success as we prepare for the introduction of four new models and a total of 11 upcoming product events. We have a clear roadmap to an exciting future and will continue to focus on ensuring that our award-winning Nissan vehicles are perfectly suited to Australian customers.” Andrew Humberstone, Vice President and Managing Director, Nissan Oceania",
      locations: [ANZ_LOCATIONS],
    },
    {
      id: 2,
      name: "Where We Operate",
      slug: "where_we_operate",
      description:
        "We have strong  local Sales teams based in Perth, Brisbane, Sydney, Melbourne and Auckland supporting our Dealers to deliver a great Customer Experience. <br /><br />Nissan New Zealand Ltd is one of the largest selling car brands in New Zealand and operates as a regional business unit (RBU) of Nissan Australia. It distributes and supports similar models to the Australian market and operates across both the north and south island of New Zealand.",
      locations: [ANZ_LOCATIONS],
    },
    {
      id: 3,
      name: "Head Office",
      slug: "head_office",
      description:
        "All are supported by a cross-functional team in our Melbourne Head Office where your career can start in Sales, Marketing, Aftersales, Dealer Network or  Corporate Functions (Finance, IT, HR, Corporate Communications and Legal). We have developed strong ties to our regional colleagues across the Middle East and Europe and you could find yourself working on projects that have impact beyond our shores.",
      locations: [ANZ_LOCATIONS],
    },
  ],
  work_day_link: `https://www.livehire.com/careers/nissan/jobs`,
};
